<template>
  <div class="dg" :title="title" role="img" :aria-label="title">
    <span v-for="(d, i) in dots" :key="i" class="dg-dot" :class="'is-' + d"></span>
  </div>
</template>

<script>
/**
 * A row of dots that shows how a small count splits into states — done,
 * active, new — the way the reference dashboard shows a call queue. Each dot
 * is one item up to `max`; past that the dots stand for shares, so the shape
 * still reads without the row running off the card.
 */
export default {
  name: "DotGrid",
  props: {
    // ordered segments: [{ count, tone }] with tone in done | active | new | idle
    segments: { type: Array, required: true },
    max: { type: Number, default: 24 },
    title: { type: String, default: "" },
  },
  computed: {
    dots() {
      const total = this.segments.reduce((a, s) => a + (Number(s.count) || 0), 0);
      if (!total) return Array(Math.min(this.max, 8)).fill("idle");
      const scale = total > this.max ? this.max / total : 1;
      const out = [];
      this.segments.forEach((s) => {
        const n = Math.round((Number(s.count) || 0) * scale);
        for (let i = 0; i < n; i++) out.push(s.tone);
      });
      return out.slice(0, this.max);
    },
  },
};
</script>

<style scoped>
.dg { display: flex; flex-wrap: wrap; gap: 4px; }
.dg-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--border-secondary); }
.dg-dot.is-done { background: var(--chart-series); opacity: 0.45; }
.dg-dot.is-active { background: var(--chart-series); }
.dg-dot.is-new { background: var(--chart-compare); }
.dg-dot.is-idle { background: var(--border-light); }
</style>
